export const INSTALL_COMMAND = "curl -sL https://windieos.com/install | sh";
export const WINDOWS_INSTALL_COMMAND = "irm https://windieos.com/install.ps1 | iex";

export const INSTALL_PLATFORMS = Object.freeze({
  unix: "unix",
  windows: "windows",
});

function platformValue() {
  if (typeof navigator === "undefined") {
    return "";
  }

  return [
    navigator.userAgentData?.platform,
    navigator.platform,
    navigator.userAgent,
  ]
    .filter(Boolean)
    .join(" ");
}

export function detectInstallPlatform() {
  const value = platformValue();

  if (/Windows/i.test(value)) {
    return INSTALL_PLATFORMS.windows;
  }

  if (/Android|iPhone|iPad|iPod/i.test(value)) {
    return null;
  }

  if (/Macintosh|Mac OS X|Linux|X11|Darwin/i.test(value)) {
    return INSTALL_PLATFORMS.unix;
  }

  return null;
}

export function getInstallPlatform() {
  return detectInstallPlatform() || INSTALL_PLATFORMS.unix;
}

export function getInstallCommand(platform = getInstallPlatform()) {
  if (platform === INSTALL_PLATFORMS.windows) {
    return WINDOWS_INSTALL_COMMAND;
  }

  return INSTALL_COMMAND;
}

export async function handleInstall(event) {
  event.preventDefault();
  const command = getInstallCommand();

  try {
    await navigator.clipboard.writeText(command);
  } catch (error) {
    // Clipboard access can be unavailable outside a secure browser context.
  }

  if (window.location.pathname !== "/") {
    window.location.assign("/?install=1#top");
    return;
  }

  window.dispatchEvent(new Event("windie:install-copy"));
  document.getElementById("top")?.scrollIntoView({ behavior: "auto" });
}
